import { render, staticRenderFns } from "./ReelSvg.vue?vue&type=template&id=1baa28f8&"
import script from "./ReelSvg.vue?vue&type=script&lang=js&"
export * from "./ReelSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports